import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
// import { PageLayout } from '@adc/ui-adc'
import PageLayout from '@adc/ui-core/components/layouts/pageLayout';
import { getWebComponentName } from '../utils';
import { useShadowStyles } from '../hooks/useShadowStyles';
const WrappedComponent = props => {
    const ref = useShadowStyles();
    return (React.createElement("div", { ref: ref },
        React.createElement(PageLayout, { ...props },
            React.createElement("slot", null))));
};
const WebButton = r2wc(WrappedComponent, {
    props: {
        width: 'string',
        horizontalPadding: 'boolean',
    },
    shadow: 'open',
});
customElements.define(getWebComponentName('page-layout'), WebButton);
